import type { Technique } from '../types';
import { ROPE_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, type RopeState } from './render';

export const rope: Technique<RopeState> = {
  id: 'rope',
  name: 'Seil / Hängung',
  category: 'physics',
  description: 'Jeder Buchstabe hängt an einem simulierten Seil und schwingt im Wind.',
  params: ROPE_PARAMS,
  renderer: 'canvas2d',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  elementCount,
};
